import styled from "styled-components";
import { EmbedTheme } from "../../utils/embeds";
import { V3BodyGrey35 } from "../ReusableStyledComponents/V3BodyGrey35";

export const EmbedAuthorWrapper = styled.div`
    display: flex;
    align-items: center;

    > div {
        &:first-child {
            margin-right: 8px;
        }
    }
`;

export const EmbedAuthorName = styled(V3BodyGrey35) <{ embedTheme: EmbedTheme }>`
    color: ${({ embedTheme }) => embedTheme === EmbedTheme.dark ? "white" : undefined};
`;